export interface KnowledgeItem {
  id: string;
  title: string;
  targetBody: string | null; // null = 通用知识
  ageTarget: string;
  content: string;
  funFact: string;
  triggerEvent: string; // 如何在3D中触发这个知识点
}

export const knowledgeData: KnowledgeItem[] = [
  {
    id: "seasons",
    title: "地球为什么会有春夏秋冬？",
    targetBody: "Earth",
    ageTarget: "10岁",
    content:
      "地球在绕太阳公转时，身体有一点'歪'——地轴倾斜了大约23.5度。这就像你拿着一个手电筒照射一个歪着的球：当北半球歪向太阳时，阳光更集中、更暖和，就是夏天；当北半球歪向远离太阳的方向时，阳光斜斜地照过来、比较分散，就是冬天。南半球的季节正好相反！地球公转一圈需要365天，所以一年有四季更替。",
    funFact: "你知道吗？水星没有四季，因为它的身体几乎没有倾斜，而且公转太快啦！",
    triggerEvent: "点击地球进入特写模式时展示",
  },
  {
    id: "moon-phases",
    title: "月亮为什么每天看起来不一样？",
    targetBody: "Moon",
    ageTarget: "10岁",
    content:
      "月球自己不会发光，它像一面大镜子，反射太阳的光。月球围绕地球公转，大约27.3天转一圈。我们在地球上看，有时候看到它被太阳照亮的正面（满月），有时候只看到一点点亮边（新月或弯月），有时候完全藏在地球的影子里（月食）。这就是月相变化！",
    funFact: "你看到的月亮总是同一面！因为月球自转和公转周期相同，这叫'潮汐锁定'。",
    triggerEvent: "点击月球进入特写模式时展示",
  },
  {
    id: "solar-eclipse",
    title: "日食是怎么发生的？",
    targetBody: "Moon",
    ageTarget: "10岁",
    content:
      "日食就像一场宇宙版的'躲猫猫'。当月球正好运行到太阳和地球中间，并且三者排成一条直线时，月球就会挡住太阳射向地球的光。地球上被月球影子遮住的地方，就会突然变暗，像是白天变成了黄昏！日全食时，你还能看到太阳周围美丽的日冕。",
    funFact: "日食不是每次新月都有哦！因为月球轨道有点倾斜，大部分时候它的影子会从地球上方或下方掠过。",
    triggerEvent: "在月球信息面板中提供'模拟日食'按钮",
  },
  {
    id: "lunar-eclipse",
    title: "月食是怎么发生的？",
    targetBody: "Moon",
    ageTarget: "10岁",
    content:
      "月食发生时，地球跑到了太阳和月球中间。太阳的光被地球挡住，地球的影子就投射到了月球上。不过月球不会完全变黑——地球大气层会把一部分阳光弯曲并散射到月球表面，这些光中红色光最多，所以月球常常变成暗红色，叫做'血月'！",
    funFact: "月食时，如果当时你站在月球上，你会看到地球把太阳完全挡住，周围有一圈红色的光环！",
    triggerEvent: "提供'月全食演示'按钮，自动跳转至真实月全食历元时刻",
  },
  {
    id: "saturn-rings",
    title: "土星为什么戴着漂亮的'项链'？",
    targetBody: "Saturn",
    ageTarget: "10岁",
    content:
      "土星的光环其实是由无数块冰块和岩石组成的，它们就像微小的'小月亮'，围绕着土星旋转。这些碎片有的只有沙粒大小，有的像房子一样大！科学家认为，光环可能是被土星强大引力撕碎的小卫星，或者是太阳系早期留下的'建筑材料'碎片。",
    funFact: "土星环虽然宽达28万公里，但厚度只有约1公里！比一张纸还薄得多（相对比例来说）。",
    triggerEvent: "点击土星进入特写模式时展示",
  },
  {
    id: "jupiter-red-spot",
    title: "木星上的'大红斑'是什么？",
    targetBody: "Jupiter",
    ageTarget: "10岁",
    content:
      "木星的大红斑是一个超级巨大的风暴！它已经吹了至少350年了——比你的爷爷的爷爷的爷爷……还要早得多！这个风暴大到可以装下整个地球。它的颜色来自木星大气中的化学物质，在不同的光照条件下，颜色也会发生变化，有时是深红色，有时偏橙色。",
    funFact: "木星转得特别快，一天只有约10小时！所以大红斑虽然在缩小，但短期内还不会消失。",
    triggerEvent: "点击木星进入特写模式时展示",
  },
  {
    id: "sun-nuclear",
    title: "太阳为什么会发光发热？",
    targetBody: "Sun",
    ageTarget: "10岁",
    content:
      "太阳就像宇宙中的一个超级大锅炉。它的核心温度高达1500万摄氏度，压力大得难以想象。在这种极端条件下，氢原子会发生'核聚变'——4个氢原子合并成1个氦原子，同时释放出巨大的能量。每一秒钟，太阳就把400万吨物质转化成能量！这些能量以光和热的形式传播到太空，给地球带来生命。",
    funFact: "太阳已经燃烧了约46亿年，但它还有约50亿年的燃料！你可以放心地晒太阳。",
    triggerEvent: "点击太阳进入特写模式时展示",
  },
  {
    id: "earth-year",
    title: "为什么一年有365天？",
    targetBody: "Earth",
    ageTarget: "10岁",
    content:
      "365天其实是地球绕太阳公转一圈需要的时间！不过这里有个有趣的区分：回归年（决定季节的周期）是365.2422天，而恒星年（相对遥远恒星转一圈）是365.25636天。两者略有差异是因为地球自转轴会像陀螺一样缓慢摆动（岁差）。我们日常使用的公历基于回归年，所以每4年闰一天来补上0.2422天的差距。",
    funFact: "火星的一年有687个地球日！如果你在火星上过生日，要差不多等两年才能再吃一次蛋糕。",
    triggerEvent: "点击地球信息面板中的'时间轴'标签时展示",
  },
  {
    id: "moon-gravity",
    title: "月球为什么不会掉下来砸到地球？",
    targetBody: "Moon",
    ageTarget: "10岁",
    content:
      "月球其实一直在'掉'向地球——但它掉的同时也在往前飞！月球以每秒约1公里的速度横向飞行，地球引力把它往自己这边拉，但因为月球飞得够快，它永远不会真的撞到地球，而是绕着地球转圈圈。这就像你用力甩一个系着绳子的球：绳子把你往中心拉，但球的惯性让它一直转。如果这个速度太快，月球会飞走；太慢，就会掉下来。现在的速度刚刚好！",
    funFact: "月球正在慢慢远离地球，每年约3.8厘米！但别担心，按这个速度，要几十亿年后才会明显感觉到。",
    triggerEvent: "点击月球信息面板中的'轨道力学'标签时展示",
  },
  {
    id: "neptune",
    title: "太阳系最远的大行星是谁？",
    targetBody: "Neptune",
    ageTarget: "10岁",
    content:
      "海王星是离太阳最远的八大行星之一（如果算上已经被降级为'矮行星'的冥王星，那冥王星更远一些）。海王星是一颗巨大的冰巨星，由水、氨和甲烷冰组成。它的风是太阳系中最猛烈的，风速可达每小时2100公里！1846年，数学家和天文学家合作，通过计算预测了海王星的位置，然后在望远镜中真的找到了它——这是人类第一次用笔和纸'发现'了一颗行星。",
    funFact: "海王星的一年相当于地球的165年！自从1846年被发现以来，它还没过完一圈呢！",
    triggerEvent: "点击海王星进入特写模式时展示",
  },
];

export const generalIntro = {
  title: "欢迎来到太阳系！",
  subtitle: "一次穿越宇宙的奇妙旅程",
  content:
    "太阳系是我们的'宇宙家园'，由一颗恒星——太阳，和围绕它旋转的八颗大行星组成。这里还有几十颗卫星（比如我们的月球）、无数小行星和彗星。每一颗行星都有自己的性格和故事。转动你的鼠标，探索这个神奇的宇宙吧！",
};
